/**
 * Resolve interview role from applicant/employee records.
 * Profile header uses employee.role; job_title may still be a legacy "Care Worker" default.
 */

const NURSE_TOKENS = ['nurse', 'registered nurse', 'rn', 'rgn', 'rmn', 'staff nurse'];
const SENIOR_TOKENS = [
  'team leader',
  'senior support',
  'senior carer',
  'senior care assistant',
  'care coordinator',
];

export function normalizeRoleText(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9 ]+/g, ' ')
    .trim();
}

export function detectInterviewRoleFamily(value) {
  const text = normalizeRoleText(value);
  if (!text) return 'support_worker';
  if (NURSE_TOKENS.some((token) => text === token || text.includes(token))) {
    return 'nurse';
  }
  if (SENIOR_TOKENS.some((token) => text.includes(token))) {
    return 'senior_support_staff';
  }
  return 'support_worker';
}

export function resolveInterviewRoleInput(employee) {
  if (!employee) return '';
  return (employee.role || employee.job_title || employee.position_applied_for || '').trim();
}

/** Role string for /interview-config/{role} — matches backend role mapping. */
export function resolveInterviewApiRole(employee) {
  const raw = resolveInterviewRoleInput(employee);
  const family = detectInterviewRoleFamily(raw);
  if (family === 'nurse') return 'nurse';
  if (family === 'senior_support_staff') return 'senior_support_staff';
  return raw || 'support_worker';
}

export function resolveVacancyJobTitle(employee) {
  const raw = resolveInterviewRoleInput(employee);
  const family = detectInterviewRoleFamily(raw);
  if (family === 'nurse') return 'Registered Nurse';
  if (family === 'senior_support_staff') return 'Senior Support Staff';
  if (raw) return raw.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  return 'Care Worker';
}